import React, { useState } from "react";
import { intl } from "LocaleWrapper";
import { FormDialog } from "components/dialogs/Dialogs";
import { VoyageSelectOption } from "components/selects/VoyageSelect";
import { ShipSelectOption } from "view/ships/components/selects/ShipSelect";
import { SailingReportForm } from "view/sailingreports/SailingReportCreateEdit";
import { useTheme } from "@mui/material";

const SailingReportCreateEditDialog = ({ open, onClose, voyage, onSailingReportAdd }: {
    open: boolean,
    onClose: () => void,
	voyage: Pick<VoyageSelectOption, "id" | "voyageNumber"> & { ship?: ShipSelectOption };
    onSailingReportAdd: () => void
}) => {

	const [ loading, setLoading ] = useState(false);

	const theme = useTheme();

	const handleOnClose = () => {
		onClose();
		setLoading(false);
	};

	return (
		<FormDialog
			open={open}
			onClose={handleOnClose}
			title={intl.formatMessage({ id: "SAILING_REPORT_ADD" })}
			form='sailingReportForm'
			loading={loading}
			maxWidth="lg"
			dialogStyling={{ content: { backgroundColor: theme.palette.mode === "dark" ? "inherit" : "#EEE" } }}>
			<React.Fragment>
				<SailingReportForm
					voyage={voyage}
					onBeforeSubmit={() => setLoading(true)}
					onSuccess={() => {
						handleOnClose();
						onSailingReportAdd();
					}}
					onAfterSubmit={() => setLoading(false)} />
			</React.Fragment>
		</FormDialog>
	);
};

export default SailingReportCreateEditDialog;
